





import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Mutation, State} from 'vuex-class';
import {User} from 'firebase';
import * as firebase from 'firebase';
import DocumentSnapshot = firebase.firestore.DocumentSnapshot;
import {MAFUser} from '@/store/User/types';

/* tslint:disable:no-console */
/* tslint:disable:max-line-length */

const userState = 'userState';
const violationNamespace = 'violationState';

@Component({
  components: {
  },
})
export default class App extends Vue {
  @State('self', {namespace: 'userState'}) public myself: MAFUser | undefined;
  @State('currentUser') public currentUser: User | undefined;
  @State('transactions', {namespace: userState}) public transactions: any;
  @State('purchases', {namespace: userState}) public purchases: any;
  @Mutation('setCurrentUser') public setCurrentUser: any;
  @Mutation('setSelf', {namespace: userState}) public setSelf: any;
  @Mutation('setSelfRef', {namespace: userState}) public setSelfRef: any;
  @Action('getUserTransactions', {namespace: userState}) public getTransactions: any;
  @Action('getPurchases', {namespace: userState}) public getPurchases: any;
  @Action('updateUser', {namespace: userState}) public updateUser: any;
  @State('allUsers', {namespace: violationNamespace}) public allUsers!: MAFUser[] | [];
  // @Action('getReview', {namespace: 'rateState'}) public getReview: any;
  /* tslint:disable:max-line-length */
  public userSet: boolean = false;
  public profileSet: boolean = false;
  public currentPhase: number = 0;
  public mailto: string = 'fethermanjuliana@gmail.com';
  public subject: string = 'MAF: Banned User';
  public body: string = 'Hi! I\'m not understanding why I was banned.I would like to communicate about unbanning my account so I can continue making authentic friendships.';

  // app initiates auth watcher for login process
  public mounted() {
    this.AuthWatcher();
  }

  // Firestore - watches authentication
  public AuthWatcher() {
    this.$auth.onAuthStateChanged( (user: any) => {
      // if we haven't set a user yet, try to set one
      if ( !this.currentUser ) {
        if ( user && !this.userSet ) {
          this.setCurrentUser(user);
          this.MyProfileWatcher();
          this.userSet = true;
        } else {
          this.setCurrentUser(undefined);
        }
      }
      // otherwise, take no action
    });
  }

  public async MyProfileWatcher() {
    if ( this.currentUser && !this.profileSet ) {

      // get user's info
      this.$firestore.collection('users').doc(this.currentUser.uid).onSnapshot((document: DocumentSnapshot) => {

        if (document.exists) {
           const user: MAFUser = new MAFUser( document.data() );

           // set the document reference for later updates
           user.setDocumentReference(document.ref);
           user.getImageUrl(this).then( async (url) => {

            user.imageURL = url;
            this.profileSet = true;

            // if (this.allUsers) {
            //   if (this.allUsers.length < 510 && user.first500 === undefined) {
            //     // user does not have "first500" designation and is within first 500 people to COMPLETE account creation
            //     // 10 person bugger for Juliana & test accounts
            //     user.first500 = true;
            //   } else if (user.first500 === undefined) {
            //     user.first500 = false;
            //   }
            // }

            this.setSelf(user);
            this.setSelfRef(document.ref);

            // get user transactions & purchase history, but only if they don't exist
            if ( !this.transactions ) {
              this.getTransactions(this.currentUser);
            }
            if ( !this.purchases ) {
              this.getPurchases();
            }
           }).catch( (e) => {
             console.error(e);
           });
        } else {
          this.setSelf(undefined);
        }
      }, (error: any) => {
         if (Vue.prototype.$auth.currentUser !== null) {
            console.log(`Error getting user: ${error}`);
          }
      });
    }
  }

  // site navigation
  @Watch('myself')
  public navigatePortal() {
    const newuser = Vue.prototype.$auth.currentUser;
    if (this.myself && this.myself.isAdmin) {
      this.$router.push('/dashboard');
    }

    // if (this.myself && this.myself.isBanned) {
    //   // user is banned from the site
    //   this.$router.push('signin');
    //   this.$snackbar.open({
    //     duration: 3000,
    //     message: 'You have been banned from using MAF. Click "OK" to contact the system administrator.',
    //     type: 'is-danger',
    //     position: 'is-bottom-left',
    //     indefinite: true,
    //     onAction: () => {
    //       window.location.href = `mailto:${this.mailto}?subject=${this.subject}&body=${this.body}`;
    //     },
    //   });
    // } else if (this.myself && newuser.emailVerified) {
      // user has a verified email

      // if (this.myself.signUpPhase !== -1) {
      //   // need to continue registration
      //   // 0 = user never started account creation or backed out to signout
      //   this.currentPhase = this.myself.signUpPhase ? this.myself.signUpPhase : 0;
      //   switch (this.myself.signUpPhase) {
      //     case 0:
      //     case 1:
      //       this.$router.push('/signup/personal');
      //       break;
      //     case 2:
      //       this.$router.push('/signup/diagnosis');
      //       break;
      //     case 3:
      //       this.$router.push('/signup/activities');
      //       break;
      //     case 4:
      //       this.$router.push('/signup/upload');
      //       break;
      //     case 5:
      //       this.$router.push('/signup/terms');
      //       break;
      //     case 6:
      //       this.$router.push('/signup/lovedone');
      //       break;
      //     case -1:
      //       // likely will not get to this point
      //       this.$router.push('/dashboard');
      //       break;
      //     default:
      //       this.$router.push('/signup/personal');
      //       break;
      //   }
      // } else {
      //   // the user has already completed account creation
      //   if (this.$route && (this.$route.name === 'home' || this.$route.name === 'terms' || this.$route.path.includes('signin'))) {
      //     // the user needs to navigate away from the login sequence
      //     this.$router.push('/dashboard');
      //   }
      // }
    // } else if (this.myself && !newuser.emailVerified && this.$route.path.includes('signin')) {
    //     this.$dialog.confirm({
    //       title: 'Email Not Verified',
    //       message: 'The email you are trying to sign-in with is not verified.<br> Would you like to receive a new verification email?',
    //       confirmText: 'Send Verification Email',
    //       type: 'is-danger',
    //       hasIcon: true,
    //       onConfirm: () => {
    //         newuser.sendEmailVerification();
    //         this.$toast.open('Email Sent!');
    //         },
    //     });
    // }
  }

}
